/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddToCartDto } from '../model/addToCartDto';
import { CartDto } from '../model/cartDto';
import { GeneratePayMercPagoDto } from '../model/generatePayMercPagoDto';
import { Payment } from '../model/payment';
import { UpdateCartDto } from '../model/updateCartDto';
import { UpdateCartOfferDto } from '../model/updateCartOfferDto';
import { DeleteCartRequestDto } from '../model/deleteCartRequestDto';
import { UltimateCartRequest } from '../model/ultimateCartRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CartService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCartAddToCartPost(body?: AddToCartDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiCartAddToCartPost(body?: AddToCartDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiCartAddToCartPost(body?: AddToCartDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiCartAddToCartPost(body?: AddToCartDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/Cart/AddToCart`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCartGetCheckoutMercadoPagoPost(body?: GeneratePayMercPagoDto, observe?: 'body', reportProgress?: boolean): Observable<Payment>;
    public apiCartGetCheckoutMercadoPagoPost(body?: GeneratePayMercPagoDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Payment>>;
    public apiCartGetCheckoutMercadoPagoPost(body?: GeneratePayMercPagoDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Payment>>;
    public apiCartGetCheckoutMercadoPagoPost(body?: GeneratePayMercPagoDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Payment>('post',`${this.basePath}/api/Cart/GetCheckoutMercadoPago`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param cdUser
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCartGetMyCartGet(cdUser?: number, observe?: 'body', reportProgress?: boolean): Observable<CartDto>;
    public apiCartGetMyCartGet(cdUser?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CartDto>>;
    public apiCartGetMyCartGet(cdUser?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CartDto>>;
    public apiCartGetMyCartGet(cdUser?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdUser !== undefined && cdUser !== null) {
            queryParameters = queryParameters.set('CdUser', <any>cdUser);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CartDto>('get',`${this.basePath}/api/Cart/GetMyCart`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param paymentId
     * @param externalReference
     * @param collectionId
     * @param collectionStatus
     * @param status
     * @param paymentType
     * @param merchantOrderId
     * @param preferenceId
     * @param siteId
     * @param processingMode
     * @param merchantAccountId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCartMeliPaymentGet(paymentId?: string, externalReference?: string, collectionId?: string, collectionStatus?: string, status?: string, paymentType?: string, merchantOrderId?: string, preferenceId?: string, siteId?: string, processingMode?: string, merchantAccountId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiCartMeliPaymentGet(paymentId?: string, externalReference?: string, collectionId?: string, collectionStatus?: string, status?: string, paymentType?: string, merchantOrderId?: string, preferenceId?: string, siteId?: string, processingMode?: string, merchantAccountId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiCartMeliPaymentGet(paymentId?: string, externalReference?: string, collectionId?: string, collectionStatus?: string, status?: string, paymentType?: string, merchantOrderId?: string, preferenceId?: string, siteId?: string, processingMode?: string, merchantAccountId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiCartMeliPaymentGet(paymentId?: string, externalReference?: string, collectionId?: string, collectionStatus?: string, status?: string, paymentType?: string, merchantOrderId?: string, preferenceId?: string, siteId?: string, processingMode?: string, merchantAccountId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (paymentId !== undefined && paymentId !== null) {
            queryParameters = queryParameters.set('payment_id', <any>paymentId);
        }
        if (externalReference !== undefined && externalReference !== null) {
            queryParameters = queryParameters.set('external_reference', <any>externalReference);
        }
        if (collectionId !== undefined && collectionId !== null) {
            queryParameters = queryParameters.set('collection_id', <any>collectionId);
        }
        if (collectionStatus !== undefined && collectionStatus !== null) {
            queryParameters = queryParameters.set('collection_status', <any>collectionStatus);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (paymentType !== undefined && paymentType !== null) {
            queryParameters = queryParameters.set('payment_type', <any>paymentType);
        }
        if (merchantOrderId !== undefined && merchantOrderId !== null) {
            queryParameters = queryParameters.set('merchant_order_id', <any>merchantOrderId);
        }
        if (preferenceId !== undefined && preferenceId !== null) {
            queryParameters = queryParameters.set('preference_id', <any>preferenceId);
        }
        if (siteId !== undefined && siteId !== null) {
            queryParameters = queryParameters.set('site_id', <any>siteId);
        }
        if (processingMode !== undefined && processingMode !== null) {
            queryParameters = queryParameters.set('processing_mode', <any>processingMode);
        }
        if (merchantAccountId !== undefined && merchantAccountId !== null) {
            queryParameters = queryParameters.set('merchant_account_id', <any>merchantAccountId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/api/Cart/MeliPayment`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCartUpdateCartOfferPost(body?: UpdateCartOfferDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiCartUpdateCartOfferPost(body?: UpdateCartOfferDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiCartUpdateCartOfferPost(body?: UpdateCartOfferDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiCartUpdateCartOfferPost(body?: UpdateCartOfferDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/Cart/UpdateCartOffer`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCartUpdateCartPost(body?: UpdateCartDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiCartUpdateCartPost(body?: UpdateCartDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiCartUpdateCartPost(body?: UpdateCartDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiCartUpdateCartPost(body?: UpdateCartDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<boolean>('post',`${this.basePath}/api/Cart/UpdateCart`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public apiCartDeleteCartDelete(body?: DeleteCartRequestDto, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
     public apiCartDeleteCartDelete(body?: DeleteCartRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
     public apiCartDeleteCartDelete(body?: DeleteCartRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
     public apiCartDeleteCartDelete(body?: DeleteCartRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<boolean>('delete',`${this.basePath}/api/Cart/DeleteCart`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

    /**
     *
     *
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
     public apiCartGenerateUltimateCartPost(body?: UltimateCartRequest, observe?: 'body', reportProgress?: boolean): Observable<CartDto>;
     public apiCartGenerateUltimateCartPost(body?: UltimateCartRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CartDto>>;
     public apiCartGenerateUltimateCartPost(body?: UltimateCartRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CartDto>>;
     public apiCartGenerateUltimateCartPost(body?: UltimateCartRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


         let headers = this.defaultHeaders;

         // authentication (Bearer) required
         if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
             headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
         }

         // to determine the Accept header
         let httpHeaderAccepts: string[] = [
             'text/plain',
             'application/json',
             'text/json'
         ];
         const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
         if (httpHeaderAcceptSelected != undefined) {
             headers = headers.set('Accept', httpHeaderAcceptSelected);
         }

         // to determine the Content-Type header
         const consumes: string[] = [
             'application/json',
             'text/json',
             'application/_*+json'
         ];
         const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
         if (httpContentTypeSelected != undefined) {
             headers = headers.set('Content-Type', httpContentTypeSelected);
         }

         return this.httpClient.request<CartDto>('post',`${this.basePath}/api/Cart/GenerateUltimateCart`,
             {
                 body: body,
                 withCredentials: this.configuration.withCredentials,
                 headers: headers,
                 observe: observe,
                 reportProgress: reportProgress
             }
         );
     }

}
